import axios from "@/axios.js"

export default {
  fetchRecentClasses({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/recentLogbokClass")
        .then((response) => {
          commit('SET_RECENT_CLASSES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchRecentClassesCount({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/recentLogbokClassCount")
        .then((response) => {
          commit('SET_RECENT_CLASSES_COUNT', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  bookLogBokClass({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/bookStudentLogbokClass", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  cancelLogBokClass({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/adminCancelStudentLogbokClass", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  editLogBokClass({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/adminEditStudentLogbokClass", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getStudentPackages({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/student_invoice", {student_id : userId})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getPoliceStationData({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/admin/viewPoliceStation")
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  downloadPDF({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/adminDownloadLogbokClass", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  sendPDF({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/adminSendLogbokClass", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
